import { Navigate, useLocation, useParams } from '@hulu/react-router-dom';
import React from 'react';

import { TemplateSystemName } from '../../../../apis/graphql/types';
import { Notification } from '../../../../components/BlueTheme';
import { NotificationType } from '../../../../components/BlueTheme/Notification/types';
import { TopBottomIndentsWrapper } from '../../../../components/BlueTheme/Wrappers/styled';
import { DHCstorage, storage } from '../../constants/reports';
import StandardDelivery from '../StandardDelivery/StandardDelivery';
import StandardDeliveryDHC from '../StandardDeliveryDHC';

type Props = {
  reportTemplateSystemName: TemplateSystemName;
  templateName: string;
};

const Preview = ({ reportTemplateSystemName, templateName }: Props): JSX.Element => {
  const { pathname } = useLocation();
  const { adEntityId } = useParams();

  const staticReportMetricFilters = storage?.getStorageData('staticFilters') || {};

  if (!staticReportMetricFilters.campaigns?.length) {
    const isMixedPath = pathname.includes('mixed');
    return <Navigate to={`../../../../../${isMixedPath ? '../direct/' : ''}${adEntityId}`} />;
  }

  switch (reportTemplateSystemName) {
    case TemplateSystemName.DPlusStandardDelivery:
      return <StandardDelivery storage={storage} templateName={templateName} />;
    case TemplateSystemName.DPlusStandardDelivery_3P:
      return <StandardDelivery storage={storage} is3PDelivery={true} templateName={templateName} />;
    case TemplateSystemName.DPlusDevice:
      return <StandardDeliveryDHC storage={DHCstorage} templateName={templateName} />;
    default:
      return (
        <TopBottomIndentsWrapper>
          <Notification
            type={NotificationType.error}
            description={`Cannot get Report Data. The service does not support ${reportTemplateSystemName} report type.`}
          />
        </TopBottomIndentsWrapper>
      );
  }
};

export default Preview;
